import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const AboutPreview = () => {
  return (
    <section className="py-16 px-6" id="about">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-4">
            {/* Section Title */}
            <div className="text-sm font-medium text-pink-500 flex items-center gap-2">
              ✨ Meet Simm
            </div>
            
            {/* Headline */}
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              The strategist who creates like a 
              <span className="relative">
                <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent"> storyteller</span>
                {/* Hand-drawn underline */}
                <svg className="absolute -bottom-2 left-0 w-full h-3" viewBox="0 0 200 12" fill="none">
                  <path 
                    d="M2 9c40-3 80-6 120-3 30 2 60 4 76 2" 
                    stroke="#ec4899" 
                    strokeWidth="2" 
                    strokeLinecap="round"
                    fill="none"
                    className="animate-pulse"
                  />
                </svg>
              </span>
            </h2>
            
            {/* Copy */}
            <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
              <p>
                I'm <strong className="text-gray-900">Simm</strong> , a content creator, UGC storyteller, and social media strategist who's partnered with brands like <span className="font-semibold text-gray-800">Amazon, Pinterest, and personal brands</span> to create work that feels real and resonates with your audience.
              </p>
              
              <p>
                With 3+ years in marketing and a creator's eye for aesthetics, I bridge strategy with storytelling  making your brand unforgettable.
              </p>
              
              <p>
                But beyond views and engagement, what really drives me is helping people and brands find their voice online. I believe content should feel like a conversation, not just another post. My goal is to take the stress out of social, make the process fun, and create stories that your audience actually connects with  because at the end of the day, people don't just remember content, they remember how it made them feel.
              </p>
            </div>
          </div>
          
          {/* Visual */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative">
              <div 
                className="p-1 rounded-2xl"
                style={{
                  background: `linear-gradient(135deg, #ffe6fe 0%, #fdecff 50%, #dee4d0 100%)`
                }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/7xbxrx08_DSC06749%20%281%29.jpg" 
                  alt="Simm Bedi - Content Creator"
                  className="w-full h-[500px] rounded-2xl object-cover"
                />
              </div>
              
              {/* Hand-drawn "Hi I'm Simm" */}
              <div className="absolute -top-8 -left-8 bg-white rounded-full px-4 py-2 shadow-lg border-2 border-pink-200 transform -rotate-12">
                <span className="text-sm font-medium text-gray-800">Hi 👋 I'm Simm</span>
                {/* Small arrow pointing to image */}
                <svg 
                  className="absolute top-full left-1/2 transform -translate-x-1/2 text-pink-200" 
                  width="20" 
                  height="10" 
                  viewBox="0 0 20 10"
                >
                  <path d="M10 0 L15 8 L5 8 Z" fill="currentColor" />
                </svg>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -bottom-4 -right-4 bg-white rounded-full p-3 shadow-lg">
              <span className="text-2xl">📸</span>
            </div>
            
            <div className="absolute top-1/2 -right-6 bg-white rounded-full p-2 shadow-lg">
              <span className="text-lg">✨</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;